import "./svg/strawberry.svg"

export default {
    name: "strawberry",
    viewBox: "100 100",
}
